module.exports = __webpack_public_path__ + "img/daeguro_icon.cf66ece8.png";